import { render, staticRenderFns } from "./appAboutus.vue?vue&type=template&id=720a4734&scoped=true"
import script from "./appAboutus.vue?vue&type=script&lang=js"
export * from "./appAboutus.vue?vue&type=script&lang=js"
import style0 from "./appAboutus.vue?vue&type=style&index=0&id=720a4734&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a4734",
  null
  
)

export default component.exports